import styled from '@emotion/styled/macro'
import Button from './Button'

const cardGridLayouts = {
    default: 'auto 1fr auto',
    single: 'auto',
    noTitle: '1fr auto',
}
export const Card = styled('div')`
    overflow: hidden;
    background-color: ${({ background = 'var(--colors-grays-0)' }) =>
        background};
    border: var(--borders-main);
    border-radius: var(--borderRadius-sm);
    /* box-shadow: var(--boxShadow-0); */
    display: ${({ display = 'grid' }) => display};
    transition: 0.4s ease all;
    ${({ clickable }) =>
        clickable
            ? 'cursor:pointer;&:hover{background: var(--colors-primary-accent);}'
            : ''}
    ${({ shrink }) => (shrink ? 'flex-shrink: 0;' : '')}
    grid-template-rows: ${({ layout = 'default', children }) =>
        cardGridLayouts[layout]};
    flex-direction: ${({ flexDirection = 'column' }) => flexDirection};
    min-height: ${({ minHeight = '4rem' }) => minHeight};
    ${({ column }) =>
        column ? `grid-column: ${column};` : 'grid-column: span 4;'}
    ${({ row }) => (row ? `grid-row: ${row};` : 'grid-row: span 6;')}
    > * {
        padding: 0.25em 0.5em;
    }
    @media (max-width: 900px) {
        margin-bottom: 0.25rem;
        ${({ noBorderMobile }) => (noBorderMobile ? 'border-radius:0;' : '')}
        ${({ mobileStyles }) => mobileStyles || ''};
    }
`
export const CardTitle = styled('h5')`
    height: fit-content;
    margin: 0;
    background: var(--colors-primary-accent);
    border-bottom: var(--borders-main);
    display: flex;
    justify-content: space-between;
    align-items: center;
    svg {
        width: 1.5em;
        height: 1.5em;
    }
    button {
        padding: 0.025rem 0.5rem;
    }
`
export const CardGridTitle = styled('h3')`
    grid-column: 1/-1;
    grid-row: span 2;
    display: flex;
    align-items: center;
`
export const CardGrid = styled('div')`
    flex: auto;
    box-sizing: border-box;
    padding: 1rem;
    display: grid;
    grid-template-columns: repeat(12, [col-start] 2fr);
    grid-template-rows: 11em;
    @media (max-width: 768px) {
        grid-template-columns: repeat(8, [col-start] 1fr);
    }
    @media (max-width: 480px) {
        /* display: initial; */
        /* grid-template-columns: repeat(4, [col-start] 1fr); */
        /* display: flex; */
        /* flex-direction: column; */
        display: flex;
        margin: 0;
        flex-direction: column;
    }
    /* grid-template-rows: repeat(auto-fill, 2rem); */
    grid-gap: 1rem;
    height: 100%;
    width: 100%;
    align-self: center;
    overflow-y: auto;
`

export const CardBody = styled('div')`
    height: 100%;
    overflow: auto;
    box-sizing: border-box;
    background: ${({ background = 'var(--colors-grays-20)' }) => background};
    padding: 1rem 0.5rem;
`
export const CardButton = styled(Button)`
    margin: 0.5rem;
    /* border-radius: 0 0 var(--borderRadius-sm) var(--borderRadius-sm); */
    border: none;
    border-top: var(--borders-main);
    padding: 0.5rem;
`
export const CardFooter = styled('div')``
export const CardBodyListElement = styled('div')`
    background: var(--colors-grays-0);
    padding: 0.5rem;
    border: var(--borders-main);
    border-radius: var(--borderRadius-sm);
    margin-bottom: 0.5rem;
    display: flex;
    justify-content: space-between;
    ${({ isActive }) =>
        isActive &&
        `background: var(--colors-primary-lighter);font-weight: bold;color:var(--colors-grays-20);`}/* background: var(--colors-primary-main); */
`
export default Card
